import axios from '@app/config/axios.config';
import { getTablesParams } from '../apiType';
import { exportExcelFile } from '@app/system/utils/dataExporter';

export type ParrainagesReconductionsModifie = {
    id: number;
    createdAt: string;
    updatedAt: string;
    raisonSociale: string;
    titre: string;
    prenom1: string;
    nom1: string;
    prenom2: string;
    nom2: string;
    adresse: string;
    cp: string;
    numeroPostal: string;
    localite: string;
    telephone1: string;
    telephone2: string;
    raisonSocialePj: string;
    libelleFacture: string;
    correspondance: string;
    accordDe: string;
    dateAccord: string;
    email: string;
    infosInternes: string;
    publicite: string;
    reconduction: boolean;
    annonceOk: boolean;
    ca: number;
    noClub: string;
    collaborateur: string;
};

export const getParrainagesReconductionsModifie = async (
    params: getTablesParams
): Promise<{
    result: ParrainagesReconductionsModifie[];
    totalCount: number;
    aggregate: any;
}> => {
    try {
        const res = await axios.get('/parrainages-reconductions-modifie', {
            params,
        });
        return res.data;
    } catch (err) {
        console.error(err);
        return { result: [], totalCount: 0, aggregate: null };
    }
};

export const getParrainagesReconductionsModifieById = async (id: string) => {
    return await axios.get(`/parrainages-reconductions-modifie/${id}`);
};

export const getParrainagesReconductionsModifieByOriginalId = async (
    originalId: string
) => {
    return await axios.get(
        `/parrainages-reconductions-modifie/by-original/${originalId}`
    );
};

export interface CreateParrainagesReconductionsModifieBody {
    raisonSociale?: string;
    titre?: string;
    prenom1?: string;
    nom1?: string;
    prenom2?: string;
    nom2?: string;
    adresse?: string;
    cp?: string;
    numeroPostal?: string;
    localite?: string;
    telephone1?: string;
    telephone2?: string;
    raisonSocialePj?: string;
    libelleFacture?: string;
    correspondance?: string;
    accordDe?: string;
    dateAccord?: string;
    email?: string;
    infosInternes?: string;
    publicite?: string;
    reconduction?: boolean;
    annonceOk?: boolean;
    ca?: number;
    noClub?: string;
    collaborateur?: string;
    parrainagesReconductionsId?: number;
}

export const createParrainagesReconductionsModifie = async (
    body: CreateParrainagesReconductionsModifieBody
) => {
    return await axios.post(`/parrainages-reconductions-modifie`, body);
};

export const validateAndCreateParrainage = async (id: string) => {
    return await axios.post(
        `/parrainages-reconductions-modifie/${id}/validate`
    );
};

export const validateAndCreateManyParrainages = async (ids: number[]) => {
    return await axios.post(
        `/parrainages-reconductions-modifie/validate-many`,
        { ids }
    );
};

export const validateAndCreateParrainageWithParams = async (
    id: string,
    mandatId: number,
    collaborateurId: number
) => {
    console.log(id, mandatId, collaborateurId);
    const res = await axios.post(
        `/parrainages-reconductions-modifie/${id}/validate`,
        {
            mandatId,
            collaborateurId,
        }
    );

    console.log('res -> ', res);

    exportExcelFile(
        res.data.factureReport.header,
        { tableData: res.data.factureReport.tableData },
        'Factures import report'
    );
    exportExcelFile(
        res.data.parrainageReport.header,
        { tableData: res.data.parrainageReport.tableData },
        'Parrainages import report'
    );

    return res;
};

export const updateParrainagesReconductionsModifie = async (
    id: string,
    body: CreateParrainagesReconductionsModifieBody
) => {
    return await axios.patch(`/parrainages-reconductions-modifie/${id}`, body);
};
